import { render } from "./ProductsInAnotherIntegrationsModal.vue?vue&type=template&id=f0a6ccd6"
import script from "./ProductsInAnotherIntegrationsModal.vue?vue&type=script&lang=js"
export * from "./ProductsInAnotherIntegrationsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__